import classNames from 'classnames'
import React from 'react'
import { Deal } from 'scenes/Dashboard/data/deals/types'
import WhyItIsAFit from 'scenes/Dashboard/scenes/DealManager/components/WhyItIsAFit.component'
import { makeStyles } from 'tss-react/mui'
import { FormHelpers, FormManager } from 'utils-next/forms'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Button, FormControl, Theme } from '@mui/material'

import { parseDealToFormData, parseFormDataToDeal, SearchFunctionEditFormData } from './DealSearchFunctionEdit.data'

export type DealSearchFunctionEditProps = ExtendableStyles &
  Testable & {
    deal: Deal
    onSubmit: (deal: Pick<Deal, 'searchFunctionId'>) => void | Promise<void>
  }

export function DealSearchFunctionEdit({ className, deal, onSubmit, ...otherProps }: DealSearchFunctionEditProps) {
  const { classes } = useStyles()

  const handleSubmit = async (
    data: SearchFunctionEditFormData,
    { setSubmitting }: FormHelpers<SearchFunctionEditFormData>
  ) => {
    const parsedData = parseFormDataToDeal(data)
    setSubmitting(true)
    await onSubmit(parsedData)
    setSubmitting(false)
  }

  return (
    <FormManager<SearchFunctionEditFormData> initialValues={parseDealToFormData(deal)} onSubmit={handleSubmit}>
      {({ handleSubmit }) => (
        <form className={classNames(className, classes.searchFunctionForm)} onSubmit={handleSubmit} {...otherProps}>
          <FormControl className={classes.field} component="fieldset">
            <WhyItIsAFit name="fitReason" />
          </FormControl>
          <Button variant="contained" color="secondary" type="submit">
            Save
          </Button>
        </form>
      )}
    </FormManager>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  searchFunctionForm: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  field: {
    marginBottom: spacing(2),
  },
}))
